import type { PaginatedResponse } from "@common/types/api";
import type { TaskItem } from "@common/types/Inventory";
import type { UseQueryOptions } from "@tanstack/react-query";
import { useQuery } from "@tanstack/react-query";
import { apiClient } from "apiClient";

type QueryParams = {
  showOnlyTaskGardenItems?: boolean;
  taskId: string | number;
  page: number;
};

export const queryKey = ({
  showOnlyTaskGardenItems = false,
  taskId,
  page
}: Partial<QueryParams> = {}) => ["inventory", taskId, page, showOnlyTaskGardenItems];

const useTaskItemsQuery = ({
  taskId,
  page,
  showOnlyTaskGardenItems = false,
  ...queryOptions
}: Pick<UseQueryOptions<PaginatedResponse<TaskItem>>, "enabled" | "staleTime"> &
  QueryParams) =>
  useQuery({
    ...queryOptions,
    queryKey: queryKey({ taskId, page, showOnlyTaskGardenItems }),
    queryFn: () =>
      apiClient.inventory.fetchTaskItems({ taskId, page, showOnlyTaskGardenItems })
  });

export default useTaskItemsQuery;
